<template>
  <div>
    <NavButton chevron :toggled="showMenu" class="hidden md:flex" @click="toggleMenu">
      Our services
    </NavButton>
    <NavMenu :show="showMenu" :showing-all-services="showAllServices" @hide="toggleMenu(false)">
      <template v-if="!showAllServices">
        <div class="md:hidden border-t-2 pt-ds-sm mb-ds-xxs mt-ds-sm text-black opacity-50 w-full">
          Services
        </div>
        <NavMenuItem
          image="nav_removals"
          url="/removals/home-removals"
          qa-tag="nav-our-services-removals"
          @click="$emit('track', 'our-services', 'removals')"
        >
          Home removals
        </NavMenuItem>
        <NavMenuItem
          image="nav_furniture"
          url="/courier-services/furniture-couriers"
          qa-tag="nav-our-services-furniture"
          @click="$emit('track', 'our-services', 'furniture')"
        >
          Furniture &amp; appliance delivery
        </NavMenuItem>
        <NavMenuItem
          image="nav_international"
          url="/removals/international-removals"
          qa-tag="nav-our-services-international"
          @click="$emit('track', 'our-services', 'international')"
        >
          International removals
        </NavMenuItem>
        <NavMenuItem
          image="nav_storage"
          url="/storage"
          qa-tag="nav-our-services-storage"
          @click="$emit('track', 'our-services', 'storage')"
        >
          Storage services
        </NavMenuItem>
        <NavMenuItem
          image="nav_van"
          url="/man-and-van"
          qa-tag="nav-our-services-van"
          @click="$emit('track', 'our-services', 'man-and-van')"
        >
          Man &amp; Van
        </NavMenuItem>
        <NavMenuItem
          image="nav_student"
          url="/removals/student-movers"
          qa-tag="nav-our-services-student"
          @click="$emit('track', 'our-services', 'student')"
        >
          Student moves
        </NavMenuItem>
        <NavMenuItem
          image="nav_car"
          url="/vehicle-delivery/car-delivery"
          qa-tag="nav-our-services-car"
          @click="$emit('track', 'our-services', 'car')"
        >
          Car transport
        </NavMenuItem>
        <NavMenuItem
          image="nav_motorcycle"
          url="/vehicle-delivery/motorcycle-delivery"
          qa-tag="nav-our-services-motorcycle"
          @click="$emit('track', 'our-services', 'motorcycle')"
        >
          Motorcycle transport
        </NavMenuItem>
        <NavMenuItem
          image="nav_piano"
          url="/removals/piano-movers"
          qa-tag="nav-our-services-piano"
          @click="$emit('track', 'our-services', 'piano')"
        >
          Piano delivery
        </NavMenuItem>
        <NavMenuItem class="mt-ds-sm h-[40px]" noyellowbar chevron @click="toggleAllServices(true)">
          All Services
        </NavMenuItem>

        <!-- mobile-only -->
        <div class="md:hidden border-t-2 mt-ds-sm text-black opacity-50 w-full" />
        <NavMenuItem
          class="md:!hidden"
          chevron
          qa-tag="nav-our-services-advice-center"
          @click="toggleHelpCentre(true)"
        >
          Our moving secrets
        </NavMenuItem>
        <NavLoginButton
          services
          qa-tag="nav-our-services-login"
          class="mt-auto"
          @click="handleLoginbutton"
        />
        <!-- end mobile-only -->
      </template>
      <template v-else>
        <NavAllServicesEn @hide="toggleAllServices(false)" />
      </template>
    </NavMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NavOurServicesBase from "~/components/base/navOurServices"

export default defineComponent({
  name: "NavOurServicesEn",
  extends: NavOurServicesBase
})
</script>
